import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="collection-filter"
// Handles dynamic loading of filter fields based on selected collection
export default class extends Controller {
  static targets = ["collectionSelect", "filterField", "filterOptions"];
  static values = {
    fieldsUrl: String
  };

  connect() {
    // Load fields if a collection is already selected
    if (this.collectionSelectTarget.value) {
      this.loadFields();
    }
  }

  collectionChanged() {
    this.loadFields();
  }

  async loadFields() {
    const collectionId = this.collectionSelectTarget.value;

    if (!collectionId) {
      this.updateFilterFieldOptions([]);
      return;
    }

    try {
      const url = `${this.fieldsUrlValue}?collection_id=${encodeURIComponent(collectionId)}`;
      const response = await fetch(url, {
        headers: {
          "Accept": "application/json"
        }
      });

      if (!response.ok) {
        console.error("Failed to fetch collection fields");
        this.updateFilterFieldOptions([]);
        return;
      }

      const fields = await response.json();
      this.updateFilterFieldOptions(fields);
    } catch (error) {
      console.error("Error fetching collection fields:", error);
      this.updateFilterFieldOptions([]);
    }
  }

  updateFilterFieldOptions(fields) {
    const select = this.filterFieldTarget;
    const currentValue = select.value;

    // Clear existing options except the first empty one
    select.innerHTML = '<option value="">Select a field...</option>';

    // Add new options
    fields.forEach(field => {
      const option = document.createElement("option");
      option.value = field.handle;
      option.textContent = `${field.display} (${field.handle})`;
      
      // Add a visual indicator for field type
      if (field.type === "BlueprintFieldToggle") {
        option.textContent += " [toggle]";
      } else if (field.type === "BlueprintFieldEnumerate") {
        option.textContent += " [dropdown]";
      } else if (field.type === "BlueprintFieldEntity") {
        option.textContent += " [entity]";
      }
      
      select.appendChild(option);
    });

    // Restore previous value if it still exists
    if (currentValue) {
      const optionExists = Array.from(select.options).some(opt => opt.value === currentValue);
      if (optionExists) {
        select.value = currentValue;
      }
    }

    // Show/hide filter options based on whether a collection is selected
    if (this.hasFilterOptionsTarget) {
      if (fields.length > 0) {
        this.filterOptionsTarget.classList.remove("hidden");
      } else if (!this.collectionSelectTarget.value) {
        this.filterOptionsTarget.classList.add("hidden");
      }
    }
  }
}
